const CustomerLogin = {
  init: function () {
    document.addEventListener('DOMContentLoaded', function () {
      const loginForm = document.querySelector('.js-login-form');
      const resetForm = document.querySelector('.js-reset-form');
      const resetSuccess = document.querySelector('.js-reset-success');
      const forgotPasswordButton = document.querySelector(
        '.js-forgot-password-button',
      );
      const backToLoginButton = document.querySelector(
        '.js-back-to-login-button',
      );

      // Show login or reset form based on URL hash or reset success
      function initializeFormVisibility() {
        if (resetSuccess && resetSuccess.value === 'true') {
          showResetForm();
        } else if (window.location.hash === '#recover') {
          showResetForm();
        } else {
          showLoginForm();
        }
      }

      function showLoginForm() {
        if (loginForm == null) return;
        loginForm.style.display = 'block';
        resetForm.style.display = 'none';
        window.location.hash = '';
      }

      function showResetForm() {
        loginForm.style.display = 'none';
        resetForm.style.display = 'block';
        window.location.hash = '#recover';
      }

      // Event listener for forgot password button
      if (forgotPasswordButton) {
        forgotPasswordButton.addEventListener('click', showResetForm);
      }

      // Event listener for back-to-login button in reset form
      if (backToLoginButton) {
        backToLoginButton.addEventListener('click', showLoginForm);
      }

      initializeFormVisibility();
    });
  },
};

export default CustomerLogin;
